import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { enablePortraitViewMessage } from '../../redux/portraitViewMessageActions';

import './Breadcrumb.scss';

const mapDispatchToProps = {
  enablePortraitViewMessage,
};

class Breadcrumb extends Component {
  static defaultProps = {
    paths: []
  }

  handleClick = (crumb) => {
    crumb.onClick();
    this.props.enablePortraitViewMessage();
  }

  render() {
    const baseClassName = 'pb-breadrumb';
    const {
      parentClassName,
      theme,
      isRtl,
    } = this.props;

    const links = this.props.paths.map(
      (crumb, i) => crumb.isLast ? <Link noSitelLocale isInternal={crumb.isInternal} parentClassName={`${baseClassName}__link--last`} href={crumb.href} key={`${i}-${crumb.href}`} onClick={()=>this.handleClick(crumb)}>{crumb.title}</Link> :<Link noSitelLocale isInternal={crumb.isInternal} parentClassName={`${baseClassName}__link`} href={crumb.href} key={`${i}-${crumb.href}`} onClick={()=>this.handleClick(crumb)}>{crumb.title}</Link>
    );

    const classes = {
      [baseClassName]: true,
      [parentClassName]: parentClassName,
      [`${baseClassName}--${theme}`]: theme,
      [`${baseClassName}--rtl`]: isRtl,
    }

    return (
      <div className={classNames(classes)}>{links}</div>
    );
  }
}

Breadcrumb.propTypes = {
  parentClassName: PropTypes.string,
  paths: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    href: PropTypes.string
  })),
  theme: PropTypes.string
};

export default connect(null, mapDispatchToProps) (Breadcrumb);



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.jsx